module.exports = __webpack_public_path__ + "assets/img/selectpatient-icon.c6a21ee6.png";